import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import TableSkeleton from "../Loader/TableSkeleton";
import tokenListStyles from "./scss/tokenList.module.scss";

const LiveSalesList = ({ list, sort }) => {
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");

  const [queryParams, setQueryParams] = useState({});

  const handleSortChange = (field, type) => {
    setSortField(field);
    setSortType(type);
    setQueryParams({
      filter_range: "",
      [field]: type,
    });
  };

  useEffect(() => {
    if (list) {
      sort([...list], sortField, sortType || false, false, true);
    }
  }, [queryParams]);

  return (
    <>
      <table className={tokenListStyles.table}>
        <thead>
          <tr>
            <th>NFT Details</th>
            <th
              onClick={() =>
                handleSortChange(
                  "description",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Properties (Type){" "}
              <i
                className={`fa-solid ${sortField === "description"
                  ? sortType === "DESC"
                    ? "fa-sort-up"
                    : "fa-sort-down"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
            // onClick={() =>
            //   handleSortChange(
            //     "Attribute",
            //     sortType === "ASC" ? "DESC" : "ASC"
            //   )
            // }
            >
              Attributes{" "}
              {/* <i
                className={`fa-solid 
              ${sortField === "Attribute"
                    ? sortType === "DESC"
                      ? "fa-sort-up"
                      : "fa-sort-down"
                    : "fa-sort"
                  }
                `}
              ></i> */}
            </th>
            <th
              onClick={() =>
                handleSortChange("price", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Price{" "}
              <i
                className={`fa-solid ${sortField === "price"
                  ? sortType === "DESC"
                    ? "fa-sort-up"
                    : "fa-sort-down"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("sellers", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Seller{" "}
              <i
                className={`fa-solid ${sortField === "sellers"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange("buyers", sortType === "ASC" ? "DESC" : "ASC")
              }
            >
              Buyer{" "}
              <i
                className={`fa-solid ${sortField === "buyers"
                  ? sortType === "DESC"
                    ? "fa-sort-down"
                    : "fa-sort-up"
                  : "fa-sort"
                  }`}
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          {list ? (
            list.map((item, index) => (
              <tr key={index}>
                <td>

                  <div class="mr-3">
                    <img
                      height={"30px"}
                      width={"30px"}
                      src={
                        item?.image || "https://www.outlookindia.com/public/uploads/editor/2021-10-08/1633687225.jpg"
                      }
                      alt={item?.name || "N/A"}
                    />
                  </div>
                  <label>
                    <a href="">{item?.name || "N/A"}</a>

                    <br />
                    <span>
                      {"Sold Out"} {item?.last_updated || "N/A"}
                    </span>
                  </label>
                </td>
                <td>{item?.description || "N/A"}</td>
                <td title={item.attributes ? item.attributes.join(', ') : ''}>{item.attributes ? item.attributes.join(', ').slice(0, 14) + '....' : "N/A"}</td>
                <td>{item?.price || "N/A"}</td>
                <td title={item?.sellers || 'N/A'}>{item?.sellers ? item.sellers.slice(0, 9) + '...' + item.sellers.slice(-4) : "N/A"}</td>
                <td title={item.buyers ? item.buyers : ''}>{item.buyers ? item.buyers.slice(0, 9) + '...' + item.buyers.slice(-4) : "N/A"}</td>
              </tr>
            ))
          ) : (
            <TableSkeleton rows={3} colSpan={6} />
          )}
        </tbody>
      </table>
    </>
  );
};

export default React.memo(LiveSalesList, isEqual);